export const skills = {
  data: [
    {
      title: "Cloud & Infra",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Architected and operated scalable, fault-tolerant backend systems on AWS, GCP, and Azure, serving millions of requests per day with sub‑200ms latency and 99.9%+ uptime.",
        "⚡ Automated infrastructure provisioning and application deployment using Terraform, GitHub Actions, and Jenkins, enabling repeatable, zero‑touch releases and cutting deployment time by 50%+",
        "⚡ Designed and maintained containerized microservices with Docker and Kubernetes (EKS/GKE), including autoscaling, service discovery, and rolling updates to handle traffic spikes without downtime",

      ],
      softwareSkills: [
        {
          skillName: "AWS",
          iconifyIconId: "skill-icons:aws-dark",
          style: {
            color: "#FF9900",
          },
        },
        // {
        //   skillName: "Netlify",
        //   iconifyIconId: "simple-icons:netlify",
        //   style: {
        //     color: "#38AFBB",
        //   },
        // },
        // {
        //   skillName: "Heroku",
        //   iconifyIconId: "simple-icons:heroku",
        //   style: {
        //     color: "#6863A6",
        //   },
        // },
        {
          skillName: "Google Cloud Platforms",
          iconifyIconId: "logos:google-cloud",
        },
        {
          skillName: "Firebase",
          iconifyIconId: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "Dynamo DB",
          iconifyIconId: "skill-icons:dynamodb-dark",
        },

        {
          skillName: "PostgreSQL",
          iconifyIconId: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        // {
        //   skillName: "MongoDB",
        //   iconifyIconId: "simple-icons:mongodb",
        //   style: {
        //     color: "#47A248",
        //   },
        // },
        {
          skillName: "Docker",
          iconifyIconId: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "Kubernetes",
          iconifyIconId: "skill-icons:kubernetes",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "GitHub Actions",
          iconifyIconId: "simple-icons:githubactions",
          style: {
            color: "#5b77ef",
          },
        },
      ],
    },

    {
      title: "Mobile Application Development",
      fileName: "MobileDevelopmentImg",
      skills: [
        "⚡ Developed and shipped scalable cross‑platform Flutter applications for iOS and Android, delivering smooth, responsive experiences to thousands of active users.",
        "⚡ Built and maintained automated CI/CD pipelines for mobile using GitHub Actions (build, test, code signing, and store deploy), improving release reliability and speeding up delivery.",
        "⚡ Monitored app health with Sentry-based observability, driving down crash rates and maintaining high uptime through proactive error tracking and performance monitoring."

      ],
      softwareSkills: [
        {
          skillName: "Flutter",
          iconifyIconId: "simple-icons:flutter",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Dart",
          iconifyIconId: "simple-icons:dart",
          style: {
            color: "#29B0EE",
          },
        },
        {
          skillName: "Android",
          iconifyIconId: "skill-icons:androidstudio-light",
          style: {
            color: "#29B0EE",
          },
        },


      ]

    },

    {
      title: "Web Application Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Built dynamic, responsive, and scalable web applications using React, leveraging modern patterns (Hooks, Context, custom hooks) and state management libraries like Redux to deliver fast, intuitive UIs across desktop and mobile.",
        "⚡ Designed and developed backend APIs in Go, Python and TypeScript (Flask/FastAPI/Node.js) with sub‑300 ms latency under heavy load, integrating with relational databases and third‑party services to power data-rich, real-time web experiences."
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          iconifyIconId: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          iconifyIconId: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "JavaScript",
          iconifyIconId: "simple-icons:javascript",
          style: {
            backgroundColor: "#FFFFFF",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "PHP",
          iconifyIconId: "simple-icons:php",
          style: {
            color: "#7377AD",
          },
        },
        {
          skillName: "ReactJS",
          iconifyIconId: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          iconifyIconId: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "NPM",
          iconifyIconId: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "MongoDB",
          iconifyIconId: "simple-icons:mongodb",
          style: {
            color: "#439743",
          },
        },
        // {
        //   skillName: "GraphQL",
        //   iconifyIconId: "simple-icons:graphql",
        //   style: {
        //     color: "#DE33A6",
        //   },
        // },
        // {
        //   skillName: "Android",
        //   iconifyIconId: "simple-icons:android",
        //   style: {
        //     color: "#3DDC84",
        //   },
        // },

        {
          skillName: "jQuery",
          iconifyIconId: "simple-icons:jquery",
          style: {
            color: "#0865A6",
          },
        },
        {
          skillName: "GraphQL",
          iconifyIconId: "simple-icons:graphql",
          style: {
            color: "#DE33A6",
          },
        },
        {
          skillName: "Python",
          iconifyIconId: "simple-icons:python",
          style: {
            color: "#3776AB",
          },
        },


        // {
        //     skillName: "Git",
        //     iconifyIconId: "simple-icons:git",
        //     style: {
        //       color: "#E94E32",
        //     },
        //   },
        //   {
        //     skillName: "GitHub",
        //     iconifyIconId: "skill-icons:github-dark",
        //   },
        //{
        // {
        //   skillName: "Wordpress",
        //   iconifyIconId: "simple-icons:wordpress",
        //   style: {
        //     color: "#207297",
        //   },
        // },
        // {
        //   skillName: "Apache",
        //   iconifyIconId: "simple-icons:apache",
        //   style: {
        //     color: "#CA1A22",
        //   },
        // },

      ],
    },

    // {
    //   title: "Full Stack Dev",
    //   fileName: "SoftwareDevelopmentImg",
    //   skills: [
    //     "⚡ Expertise in building scalable software systems to meet diverse business needs.",
    //     "⚡ Ability to lead and collaborate in Agile environments, ensuring timely delivery of software.",
    //     "⚡ Adept at integrating automated processes to enhance productivity and reduce manual effort.",
    //     "⚡ Focus on ensuring application stability, reliability, and performance through rigorous testing and monitoring.",
    //   ],
    //   softwareSkills: [
    //     {
    //       skillName: "HTML5",
    //       iconifyIconId: "simple-icons:html5",
    //       style: {
    //         color: "#E34F26",
    //       },
    //     },
    //     {
    //       skillName: "CSS3",
    //       iconifyIconId: "fa-css3",
    //       style: {
    //         color: "#1572B6",
    //       },
    //     },
    //     {
    //       skillName: "JavaScript",
    //       iconifyIconId: "simple-icons:javascript",
    //       style: {
    //         backgroundColor: "#FFFFFF",
    //         color: "#F7DF1E",
    //       },
    //     },
    //     // {
    //     //   skillName: "PHP",
    //     //   iconifyIconId: "simple-icons:php",
    //     //   style: {
    //     //     color: "#7377AD",
    //     //   },
    //     // },
    //     {
    //       skillName: "ReactJS",
    //       iconifyIconId: "simple-icons:react",
    //       style: {
    //         color: "#61DAFB",
    //       },
    //     },
    //     // {
    //     //   skillName: "NodeJS",
    //     //   iconifyIconId: "simple-icons:node-dot-js",
    //     //   style: {
    //     //     color: "#339933",
    //     //   },
    //     // },
    //     {
    //       skillName: "NPM",
    //       iconifyIconId: "simple-icons:npm",
    //       style: {
    //         color: "#CB3837",
    //       },
    //     },
    //     {
    //       skillName: "MongoDB",
    //       iconifyIconId: "simple-icons:mongodb",
    //       style: {
    //         color: "#439743",
    //       },
    //     },
    //    
    //     // {
    //     //   skillName: "jQuery",
    //     //   iconifyIconId: "simple-icons:jquery",
    //     //   style: {
    //     //     color: "#0865A6",
    //     //   },
    //     // },
    //     // {
    //     //   skillName: "Wordpress",
    //     //   iconifyIconId: "simple-icons:wordpress",
    //     //   style: {
    //     //     color: "#207297",
    //     //   },
    //     // },
    //     // {
    //     //   skillName: "Apache",
    //     //   iconifyIconId: "simple-icons:apache",
    //     //   style: {
    //     //     color: "#CA1A22",
    //     //   },
    //     // },
    //     {
    //       skillName: "Flutter",
    //       iconifyIconId: "simple-icons:flutter",
    //       style: {
    //         color: "#02569B",
    //       },
    //     },
    //     // {
    //     //   skillName: "Dart",
    //     //   iconifyIconId: "simple-icons:dart",
    //     //   style: {
    //     //     color: "#29B0EE",
    //     //   },
    //     // },
    //     // {
    //     //   skillName: "Android",
    //     //   iconifyIconId: "skill-icons:androidstudio-light",
    //     //   style: {
    //     //     color: "#29B0EE",
    //     //   },
    //     // },
    //     {
    //       skillName: "Git",
    //       iconifyIconId: "simple-icons:git",
    //       style: {
    //         color: "#E94E32",
    //       },
    //     },
    //     // {
    //     //   skillName: "GitHub",
    //     //   iconifyIconId: "skill-icons:github-dark",
    //     // },
    //     // {
    //     //   skillName: "GitLab",
    //     //   iconifyIconId: "skill-icons:gitlab-dark",
    //     // },
    //     // {
    //     //   skillName: "C",
    //     //   iconifyIconId: "simple-icons:c",
    //     //   style: {
    //     //     color: "#E94E32",
    //     //   },
    //     // },
    //     // {
    //     //   skillName: "C#",
    //     //   iconifyIconId: "skill-icons:cs",
    //     // },
    //     // {
    //     //   skillName: "C++",
    //     //   iconifyIconId: "simple-icons:cplusplus",
    //     //   style: {
    //     //     color: "#E94E32",
    //     //   },
    //     // },
    //     {
    //       skillName: "Python",
    //       iconifyIconId: "simple-icons:python",
    //       style: {
    //         color: "#3776AB",
    //       },
    //     },
    //     // {
    //     //   skillName: "Anaconda",
    //     //   iconifyIconId: "skill-icons:anaconda-dark",
    //     // },
    //     // {
    //     //   skillName: "Bash",
    //     //   iconifyIconId: "skill-icons:bash-light",
    //     // },
    //     // {
    //     //   skillName: "Java",
    //     //   iconifyIconId: "simple-icons:java",
    //     //   style: {
    //     //     color: "#f89820",
    //     //   },
    //     // },

    //     // {
    //     //   skillName: "Visual Basic",
    //     //   iconifyIconId: "simple-icons:dot-net",
    //     //   style: {
    //     //     color: "#029FCE",
    //     //   },
    //     // },

    //     {
    //       skillName: "MySQL",
    //       iconifyIconId: "simple-icons:mysql",
    //       style: {
    //         color: "#4479A1",
    //       },
    //     },

    //   ],
    // },
  ],
};